import { faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function setGPIO() {
    return (
        <div data-cy="historic-controller-setGPIO">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.setGPIO" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faToggleOn} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
